import { render, staticRenderFns } from "./SecondaryUsers.vue?vue&type=template&id=e2cb1474&"
import script from "./SecondaryUsers.vue?vue&type=script&lang=ts&"
export * from "./SecondaryUsers.vue?vue&type=script&lang=ts&"
import style0 from "./SecondaryUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports